import React,{Component} from 'react';
import {PostData} from '../../../../service/postData';
import {sendNotification} from '../../../../_notificationSettings/notificationPanel';
import { MDBDataTableV5 } from 'mdbreact';
import { numberFormat } from '../../../../config/numberFormat';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import QuickPaymentPurchaseHistory from "../../userPurchase/quickPurchasePaymentHistory";
import Modal from "react-modal"; 
import QuickPaymentHistory from "../../userSale/quickPaymentHistory";
import 'bootstrap-daterangepicker/daterangepicker.css';
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import * as FileSaver from 'file-saver';

import DownloadBtnPurchaseInvoicePdf from "../../Invoices/Purchase/DownloadBtnPurchaseInvoicePdf";
import PrintBtnPurchaseInvoicePdf from "../../Invoices/Purchase/PrintBtnPurchaseInvoicePdf";
import DownloadBtnPurchaseReturnInvoicePdf from "../../Invoices/PurchaseReturn/DownloadBtnPurchaseReturnInvoicePdf";
import PrintBtnPurchaseReturnInvoicePdf from "../../Invoices/PurchaseReturn/PrintBtnPurchaseReturnInvoicePdf";

let _signingId = '0';
let _businessId = '0';
let _companyId = '0';
let _businessSetting = {};
 
let columns = [
    {
        label: '#',
        field: 'srNo',
        width: 20,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': '#',
        },
    },
    {
        label: 'Date',
        field: 'invoice_date',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Date',
        },
    },
    {
        label: 'Invoice No.',
        field: 'invoice_no',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Invoice No.',
        },
    },
    {
        label: 'Party Name',
        field: 'party_name',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Party Name',
        },
    },
    {
        label: 'Transaction Type',
        field: 'sale_type',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Party Type',
        },
    },
    {
        label: 'Payment Type',
        field: 'payment_type',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Party Type',
        },
    },
    {
        label: 'Amount',
        field: 'total_amount',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Amount',
        },
    },
    {
        label: 'Balance Due',
        field: 'balance',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'Balance Due',
        },
    },
    {
        label: 'Status',
        field: 'status',
        width: 150,
        attributes: {
        'aria-controls': 'DataTable',
        'aria-label': 'status',
        },
    },
    {
        label: 'Action',
        field: 'actionExtra',
        width: 100,
    }
];
let _loader = 'glb-ldr-prt active';
let _currentYear = moment().format('YYYY');
let _startDateYaer = "01/01/"+_currentYear;
let _endDateYaer = "12/31/"+_currentYear;
export default class userSaleListPanel extends Component{
    constructor(props){
        super(props);    
        
        let _UserSession = localStorage.getItem("vs_UserSession");
        if (_UserSession!=undefined || _UserSession!=null) {
        _UserSession = JSON.parse(_UserSession);
        _signingId = _UserSession.loginId;
        _businessId = _UserSession.tokenKey;
        _businessSetting = _UserSession.businessSetting;
        }

        let _companySession = localStorage.getItem("vs_UserCompanySession");
        if (_companySession!=undefined || _companySession!=null) {
        _companySession = JSON.parse(_companySession);
        _businessId = _companySession.business_id;
        _companyId = _companySession.company_id;
        }

        if(_businessSetting.DueDatesPaymentTerms == 1){
            columns = [
                {
                    label: '#',
                    field: 'srNo',
                    width: 20,
                    attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': '#',
                    },
                },
                {
                    label: 'Date',
                    field: 'invoice_date',
                    width: 150,
                    attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Date',
                    },
                },
                {
                    label: 'Invoice No.',
                    field: 'invoice_no',
                    width: 150,
                    attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Invoice No.',
                    },
                },
                {
                    label: 'Party Name',
                    field: 'party_name',
                    width: 150,
                    attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Party Name',
                    },
                },
                {
                    label: 'Transaction Type',
                    field: 'sale_type',
                    width: 150,
                    attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Party Type',
                    },
                },
                {
                    label: 'Payment Type',
                    field: 'payment_type',
                    width: 150,
                    attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Party Type',
                    },
                },
                {
                    label: 'Amount',
                    field: 'total_amount',
                    width: 150,
                    attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Amount',
                    },
                },
                {
                    label: 'Balance Due',
                    field: 'balance',
                    width: 150,
                    attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Balance Due',
                    },
                },
                {
                    label: 'Status',
                    field: 'status',
                    width: 150,
                    attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'status',
                    },
                },
                {
                    label: 'Due Date',
                    field: 'due_date',
                    width: 150,
                    attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'due dates',
                    },
                },
                {
                    label: 'Action',
                    field: 'actionExtra',
                    width: 100,
                }
            ];
        }
 
        this.state = {
            buttonTitle:'Add Sale',
            isLoaded : true,
            modalPaymentHistory: false,
            modalPaymentHistoryPurchase: false,
            transactionArray :[],
            transactionArrayFilter:[],
            DueDatesPaymentTerms : _businessSetting.DueDatesPaymentTerms ? _businessSetting.DueDatesPaymentTerms : 0,
            businessId:_businessId,
            company_id:_companyId,
            userId : _signingId,
            name :  null,
            paidAmount:0,
            unpaidAmount:0,
            total:0,
            startDate : moment().startOf('month').format('YYYY-MM-DD'),
                  endDate : moment().endOf('month').format('YYYY-MM-DD'),
            dateLabel : '',
            partyData : [],
            activeTransactionPaymentKey : 'ALL',
            activeTransactionKey : 'ALL',
            activePartyKey : 'ALL',
            overDueAmt : 0,

            pageCount: 10,
            page: 1,
            totalCount: 0,
            pageShow: 0,
            setPage: 1,
            searchInvNo : '',
            errors: {
                name : '',
            }
        }
    }

    async componentDidMount ()
    {   
        this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,this.state.page,this.state.activePartyKey,this.state.searchInvNo,this.state.pageCount);
        this.getPartyListData(this.state.company_id);
    }

    getTransactionAmountCalculate(_page,searchInvSend,pageCount,_type,_partyIDS){
        const requestData = JSON.stringify({
            business_id: this.state.businessId,
            company_id: this.state.company_id,
            type: _type,
            isDateFilter: true,
            partyId : parseFloat(_partyIDS),
            start_date: this.state.startDate,
            end_date: this.state.endDate,
            pageCount: pageCount,
            page: _page,
            search_inv_no:searchInvSend,
        });

        PostData(global.userPurchaseTransactionCountList, requestData, "POST")
        .then((result) => {
        let responseJson = result;
        let totalValueSign = "";
        if (responseJson.success == false) {
            this.setState({
            paidAmount: 0,
            unpaidAmount: 0,
            total: 0,
            totalValueSign : totalValueSign,
            });
        } else {
            if(this.state.activeTransactionKey === 'DEBIT NOTE'){
                totalValueSign = "-";
            }
            this.setState({
                paidAmount: responseJson.totalTransAmt - responseJson.totalBalanceAmt,
                unpaidAmount: responseJson.totalBalanceAmt,
                total: responseJson.totalTransAmt,
                totalCount: responseJson.totalCount,
                totalValueSign : totalValueSign,
            });
        }
        })
        .catch((error) => this.setState({ error}));
    }
    getPartyListData() {
        let _partyData = [];
        let _url_GetData =
        global.userPartyList + "?company_id=" + this.state.company_id;
        PostData(_url_GetData, "", "GET").then((result) => {
            let responseJson = result;
            if (responseJson.success == false) {
                this.setState({ isLoaded: true });
            } else {
                if (responseJson.response) {
                _partyData = responseJson.response;
                }
                this.setState({ partyData: _partyData, isLoaded: true });
            }
        }).catch((error) => this.setState({ error, isLoaded: false}));
    }

    getSaleListData(_type,_paymentStatus,_page,_partyIDS,searchInvSend,pageCount){
        console.log(_page);
        let _transArray = [];
        let _paidAmt = 0;
        let _unpaidAmt = 0;
        let _totalAmt = 0;
        let _overDueAmt = 0;
        
        const requestData = JSON.stringify({
            business_id: this.state.businessId,
            company_id: this.state.company_id,
            type:_type,
            payment_status : _paymentStatus,
            partyId : parseFloat(_partyIDS),
            isDateFilter: true,
            start_date: this.state.startDate,
            end_date: this.state.endDate,
            pageCount: pageCount,
            page: _page,
            search_inv_no:searchInvSend,
        });
        console.log(requestData);
        PostData(global.userPurchaseTransactionList, requestData,'POST').then((result) => {
            this.getTransactionAmountCalculate(_page,searchInvSend,pageCount,_type,_partyIDS);
            let responseJson = result;
            if(responseJson.success == false)
            {  
                this.setState({
                    transactionArrayFilter:_transArray,
                    itemArray:_transArray,isLoaded:true,
                    paidAmount:_paidAmt,
                    unpaidAmount:_unpaidAmt,
                    total:_totalAmt,
                    overDueAmt : _overDueAmt,
                });
            }
            else
            {
                if (responseJson.response) {
                    _transArray = responseJson.response;
                    _transArray.map((itm, i) =>{
                        _paidAmt = responseJson.totalPaidAmount;
                        _unpaidAmt = responseJson.totalUnPaidAmount;
                        _overDueAmt = responseJson.totalOverDueAmount
                        _totalAmt = parseFloat(_paidAmt) + parseFloat(_unpaidAmt) + parseFloat(_overDueAmt);
                    });
                }
                if(_transArray.length == 0){
                    _overDueAmt = 0;
                }            
                this.setState({transactionArrayFilter:_transArray,itemArray:_transArray,isLoaded:true,paidAmount:_paidAmt,unpaidAmount:_unpaidAmt,total:_totalAmt,overDueAmt: _overDueAmt,pageShow: responseJson.pageShow,});
            }             
        })
        .catch(error => this.setState({ error, isLoaded: false }));
    }
    
    createDuplicateToSale(value,type){
        confirmAlert({
            title: 'Confirm to create duplicate sale',
            message: 'Are you sure you want to delete?',
            buttons: [
            {
                label: 'Yes',
                className: 'btn btn-danger',
                onClick: () => {
                    const requestData = JSON.stringify({
                        sale_id: value,
                        type_value: type
                    });
                    PostData(global.convertToSaleTransaction, requestData,'POST').then((result) => {
                        let responseJson = result;                
                        if(responseJson.success == false)
                        {
                            sendNotification("Error Message 😓",responseJson.message,"danger");
                            return;
                        }
                        else
                        {
                            sendNotification("Success Message 👍",responseJson.message,"success");
                            this.getSaleListData();
                            return;
                        }
                    });
                }
            },
            {
                label: 'No',
                className: 'btn btn-dark',
            }
            ]
        });
    }

    loadTranscListing(){
        let dataList = [];
        let rows = [];
        if(this.state.isLoaded == true)
        {
            let _transDetails = this.state.transactionArrayFilter;
            if(_transDetails.length > 0){
                let _i=0;
                _transDetails.map((value,index) => {   
                    _i++;                  
                    let _typeSend = "&tType=Report";
                    let _trans_duplicate_normal = value.trans_duplicate_normal ? value.trans_duplicate_normal : '';
                    let _editActionUrl = global.webUrl+'business/add-purchase/?auth='+value.id+_typeSend;
                    if(value.type == 'PURCHASE'){
                        _editActionUrl = global.webUrl+'business/add-purchase/?auth='+value.id+_typeSend;
                    }
                    else if(value.type == 'DEBIT NOTE'){
                        _editActionUrl = global.webUrl+'business/add-purchase-debit-note/?auth='+value.id+_typeSend;
                    }

                    let _duplicateUrl = global.webUrl+'business/manage-purchase-to-duplicate/?auth='+value.id+'&tType=DUPLICATE';
                    if(value.customPrefix == 'DN'){
                        _duplicateUrl = global.webUrl+'business/manage-purchase-to-duplicate-return/?auth='+value.id;
                    }

                    let _actionHistory = "";
                    let _actionExtra = '';
                    if(value.type == 'PURCHASE'){
                        _actionExtra = (
                            <div className="btn-group" role="group">
                                <button type="button" id="btnGroupVerticalDrop3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="fa fa-ellipsis-v"></i>
                                </button>
                                <div className="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                                    {_trans_duplicate_normal === 'Normal' &&
                                        <a className="dropdown-item" href={_duplicateUrl}>
                                            Duplicate
                                        </a>
                                    }
                                    {_trans_duplicate_normal !== 'Duplicate' &&
                                        <a className="dropdown-item" href={_editActionUrl}>
                                            View/Edit Details
                                        </a>
                                    }
                                    {_trans_duplicate_normal === 'Normal' &&
                                        <a className="dropdown-item" href={global.webUrl+'business/manage-purchase-make-payment/?auth='+value.id}>
                                            Make Payment
                                        </a>
                                    }
                                    {/* canCreateReturn is false once every line is fully returned */}
                                    {_trans_duplicate_normal === 'Normal' && value.canCreateReturn !== false &&
                                        <a className="dropdown-item" href={global.webUrl+'business/add-purchase-debit-note/?auth='+value.id+"&tType=DEBIT NOTE&isConvert=true"}>
                                            Convert to Return
                                        </a>
                                    }
                                    <a className="dropdown-item" href="javascript:void(0)" data-id={value.id} onClick={this.clickToDelete.bind(this,value.id,'Purchase ')}>
                                        Delete
                                    </a>
                                    
                                    <DownloadBtnPurchaseInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                                    <Link
                                        className="dropdown-item"
                                        to={"/business/PurchasePdfDialog/?auth=" + value.id}
                                        target="_blank"
                                    >
                                        Preview
                                    </Link>
                                    <PrintBtnPurchaseInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                                    {/* <ButtonPdf transactionId={value.id} isChallanPreview={false}/> */}
                                </div>
                            </div>
                        );
                    }
                    else if(value.type == 'DEBIT NOTE'){
                        
                        _actionExtra = (
                            <div className="btn-group" role="group">
                                <button type="button" id="btnGroupVerticalDrop3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="fa fa-ellipsis-v"></i>
                                </button>
                                <div className="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                                    
                                    {_trans_duplicate_normal !== 'Duplicate' &&
                                        <a className="dropdown-item" href={_editActionUrl}>
                                            View/Edit Details
                                        </a>
                                    }
                                    <a className="dropdown-item" href="javascript:void(0)" data-id={value.id} onClick={this.clickToDelete.bind(this,value.id,'Purchase ')}>
                                        Delete
                                    </a>

                                    {_trans_duplicate_normal === 'Normal' &&
                                        <a className="dropdown-item" href={_duplicateUrl}>
                                            Duplicate
                                        </a>
                                    }
                                    {_trans_duplicate_normal === 'Normal' &&
                                        <a className="dropdown-item" href={global.webUrl+'business/manage-purchase-make-payment-in/?auth='+value.id}>
                                            Receive Payment
                                        </a>
                                    }
                                    {(value.paymentHistory !== '' || value.paid_amount > 0) && (
                                        <a
                                            className="dropdown-item"
                                            href="javascript:void(0)"
                                            data-id={value.id}
                                            onClick={this.clickToPaymentSaleHistory.bind(
                                                this,
                                                value.id,
                                                value.paymentHistory,
                                                value.received_amount
                                            )}
                                        >
                                            Payment History
                                        </a>
                                    )}

                                    <DownloadBtnPurchaseReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                                    <Link
                                        className="dropdown-item"
                                        to={"/business/purchaseReturnPdfDialog/?auth=" + value.id}
                                        target="_blank"
                                    >
                                        Preview
                                    </Link>
                                    <PrintBtnPurchaseReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                                    {/* <ButtonPdf transactionId={value.id} isChallanPreview={false}/> */}
                                </div>
                            </div>
                        );
                    }
                    else{
                        _actionExtra = (
                            <div className="btn-group" role="group">
                                <button type="button" id="btnGroupVerticalDrop3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i className="fa fa-ellipsis-v"></i>
                                </button>
                                <div className="dropdown-menu" aria-labelledby="btnGroupVerticalDrop1">
                                    
                                    {_trans_duplicate_normal === 'Normal' &&
                                        <a className="dropdown-item" href={_duplicateUrl}>
                                            Duplicate
                                        </a>
                                    }
                                    {_trans_duplicate_normal === 'Normal' &&
                                        <a className="dropdown-item" href={global.webUrl+'business/manage-purchase-make-payment-in/?auth='+value.id}>
                                            Receive Payment
                                        </a>
                                    }
                                    <DownloadBtnPurchaseReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                                    <Link
                                        className="dropdown-item"
                                        to={"/business/purchaseReturnPdfDialog/?auth=" + value.id}
                                        target="_blank"
                                    >
                                        Preview
                                    </Link>
                                    <PrintBtnPurchaseReturnInvoicePdf auth={value.id} loading={(isLoading) => this.setState({isPdfLoading: isLoading})}/>
                                    {/* <ButtonPdf transactionId={value.id}/> */}
                                </div>
                            </div>
                        );
                    }

                    let _textShow = 'Debit Note';
                    if(value.type == 'PURCHASE'){
                        _textShow = 'Purchase';
                    }

                    let _saleType = <span className="badge badge-warning">UNPAID</span>;
                    if(value.payment_paid == 'PARTIAL'){
                        _saleType = <span className="badge badge-info">{value.payment_paid}</span>;
                    }
                    else if(value.payment_paid == 'PAID'){
                        _saleType = <span className="badge badge-success">{value.payment_paid}</span>;
                    } 
                          
                    let _pageAK = this.state.setPage;    
                    let _showDupL = '';
                    if(_trans_duplicate_normal == 'Duplicate'){
                        _showDupL = ' (Duplicate)';
                    }
                    let _totalAmtShow = numberFormat(value.total_amount);
                    if(parseFloat(value.payable_amount) >0){
                        _totalAmtShow = numberFormat(value.payable_amount);
                    }
                    if(this.state.DueDatesPaymentTerms == 1){
                        let _dueDates =  value.payment_term_due_date;
                        if(value.payment_term_due_date == '0' || value.payment_term_due_date == '' || value.payment_term_due_date == ''){
                            _dueDates = 'NA'
                        }
                        if(value.payment_term_due_status.length > 3){
                          _saleType = <span className="badge badge-danger">Overdue</span>;
                        }
                        rows.push({
                        srNo: ((_pageAK - 1) * this.state.pageCount) + _i,
                        invoice_date: value.invoice_date,
                        invoice_no:value.invoice_no + _showDupL, //value.customPrefix+' #'+value.invoice_no,
                        party_name:value.party_name,
                        sale_type: _textShow, //_saleType,
                        payment_type: value.payment_type,
                        total_amount:_totalAmtShow,
                        balance: numberFormat(value.balance),
                        status: _saleType,
                        due_date: _dueDates,
                        actionExtra: _actionExtra,
                        });
                    }
                    if(this.state.DueDatesPaymentTerms == 0){
                        rows.push({
                        srNo: ((_pageAK - 1) * this.state.pageCount) + _i,
                        invoice_date: value.invoice_date,
                        invoice_no:value.invoice_no + _showDupL, //value.customPrefix+' #'+value.invoice_no,
                        party_name:value.party_name,
                        sale_type: _textShow, //_saleType,
                        payment_type: value.payment_type,
                        total_amount:_totalAmtShow,
                        balance: numberFormat(value.balance),
                        status: _saleType,
                        actionExtra: _actionExtra,
                        });
                    }
                });
            }
        }

        if (rows) {
            dataList = {
                columns: columns,
                rows: rows
            };
        }
        return dataList;
    }

    handleCallBackDate = (start, end) => {        
        this.setState({startDate:start.format('YYYY-MM-DD'),endDate:end.format('YYYY-MM-DD')});
        this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,this.state.page,this.state.activePartyKey);
    };
    clickToPaymentHistory(value, paymentHistory, paidAmount) {
        //console.log(paymentHistory);return false;
        this.setState({
        modalPaymentHistoryPurchase: true,
        activePaymentHistory: paymentHistory,
        trasactionHisId: value.id,
        paidAmount: paidAmount,
        transactionType: value.type
        });
    }

    clickToPaymentSaleHistory(value, paymentHistory, receivedAmount) {
        this.setState({
        modalPaymentHistory: true,
        activePaymentHistory: paymentHistory,
        trasactionHisId: value,
        receivedAmount: receivedAmount,
        });
    }
    closeModalHandler = (e) => {
        if (e == "modalPaymentHistory") {
        this.setState({
            modalPaymentHistory: false,
            activePaymentHistory: [],
            trasactionHisId: 0,
            receivedAmount: 0,
        });
        } else if (e == "modalPaymentPurchaseHistory") {
        this.setState({
            modalPaymentHistoryPurchase: false,
            activePaymentHistory: [],
            trasactionHisId: 0,
            receivedAmount: 0,
            transactionType: ''
        });
        }
    };
    clickToDelete(value,type)
    {
        confirmAlert({
            title: 'Confirm to delete',
            message: 'Are you sure you want to delete?',
            buttons: [
            {
                label: 'Yes',
                className: 'btn btn-danger',
                onClick: () => {
                    const requestData = JSON.stringify({
                        sale_id: value,
                        type_value: type
                    });
                    PostData(global.deleteSaleTransaction, requestData,'POST').then((result) => {
                        let responseJson = result;                
                        if(responseJson.success == false)
                        {
                            sendNotification("Error Message 😓",responseJson.message,"danger");
                            return;
                        }
                        else
                        {
                            sendNotification("Success Message 👍",responseJson.message,"success");
                            //this.getSaleListData();
                            this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,this.state.page,this.state.activePartyKey);
                            return;
                        }
                    });
                }
            },
            {
                label: 'No',
                className: 'btn btn-dark',
            }
            ]
        });
    }

    exportData = (event) =>{
      let _itemDetails = this.state.itemArray;
      try {
        let totalAmount = 0;
        _itemDetails.map((data) => {
          totalAmount += parseFloat(data.total_amount);
        });
  
        _itemDetails = _itemDetails.map((data) => {
  
          let newData = {
            'Date': data.invoice_date,
            'Order No': data.order_number,
            'Invoice No': data.invoice_no,
            'Party Name': data.party_name,
            'Party Phone No.': data.party_phone,
            'Transaction Type': data.type,
            'Total Amount': data.total_amount,
            'Payment Type': data.payment_type,
            'Received/Paid Amount': data.received_amount,
            'Balance Due': data.balance,
            'Payment Status': data.payment_paid,
            'Description': data.description,
            'Transport Name': data.TransportDetailField1,
            'Vehicle Number': data.TransportDetailField2,
          }
           return newData;
        });
  
        let totalAmountRow = {
          'Date': '',
          'Order No': '',
          'Invoice No': '',
          'Party Name': '',
          'Party Phone No.': '',
          'Transaction Type': 'Total',
          'Total Amount': totalAmount,
          'Payment Type': '',
          'Received/Paid Amount': '',
          'Balance Due': '',
          'Payment Status': '',
          'Description': '',
          'Transport Name': '',
          'Vehicle Number': '',
        };
  
        _itemDetails.push({});
        _itemDetails.push(totalAmountRow);
        var ws = XLSX.utils.json_to_sheet(_itemDetails);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb,ws,"Purchase Report");
        const wbout = XLSX.write(wb, {type:'array', bookType:"xlsx"});
        let length = 6;
        let uniqueNo = String(Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1)));
        let fileName = 'export_purchase_'+moment().format('YYYY-MM-DD')+'.xlsx';
        const data = new Blob([wbout], {type: "xlsx"});
        FileSaver.saveAs(data, fileName);
  
      } catch (err) {
        //alert('Unknown Error: ' + JSON.stringify(err));
        throw err;
      }
    }
  
   changeTypeFilter = (e) => {        
        this.setState({activeTransactionKey : e.target.value});
        this.getSaleListData(e.target.value,this.state.activeTransactionPaymentKey,this.state.page,this.state.activePartyKey);
    }
    changeTypePayStausFilter = (e) => {        
        this.setState({activeTransactionPaymentKey : e.target.value});
        this.getSaleListData(this.state.activeTransactionKey,e.target.value,this.state.page,this.state.activePartyKey);
    }

    changePartyFilter = (e) => {        
        this.setState({activePartyKey : e.target.value});
        this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,this.state.page,e.target.value);
    }

    render(){
        if(this.state.isLoaded == true){
            _loader = 'glb-ldr-prt';
        }
        const {errors} = this.state;
        return(
            <React.Fragment>
                <div className="content">
                    <div className="block">
                        <div className="row">
                            <div className="col-md-12">
                                <h5># Purchase Report</h5>
                                <div className="block">
                                    <div className="block-content" style={{marginTop: '-20px'}}>
                                        <div className="row items-push">
                                            <div className="row col-lg-12">
                                                <div className="col-lg-10">
                                                    <span>Filter : </span>
                                                    <DateRangePicker
                                                        initialSettings={{ 
                                                            startDate: this.state.startDate, 
                                                            endDate: this.state.endDate,
                                                            locale: {
                                                                format: 'YYYY-MM-DD',
                                                            },
                                                            ranges: {
                                                                Today: [moment().toDate(), moment().toDate()],
                                                                Yesterday: [
                                                                moment().subtract(1, 'days').toDate(),
                                                                moment().subtract(1, 'days').toDate(),
                                                                ],
                                                                'Last 7 Days': [
                                                                moment().subtract(6, 'days').toDate(),
                                                                moment().toDate(),
                                                                ],
                                                                'Last 30 Days': [
                                                                moment().subtract(29, 'days').toDate(),
                                                                moment().toDate(),
                                                                ],
                                                                'This Month': [
                                                                moment().startOf('month').toDate(),
                                                                moment().endOf('month').toDate(),
                                                                ],
                                                                'Last Month': [
                                                                moment().subtract(1, 'month').startOf('month').toDate(),
                                                                moment().subtract(1, 'month').endOf('month').toDate(),
                                                                ],
                                                            }
                                                        }}
                                                        onCallback={this.handleCallBackDate}
                                                    >
                                                    <input type="text" className="form-control col-4" style={{display: 'inline-block'}}/>
                                                    </DateRangePicker>

                                                    <select onChange={this.changeTypeFilter} className="form-control col-2" style={{display: 'inline-block',marginLeft: '4px'}}>
                                                        <option value="ALL">All Transaction</option>
                                                        <option value="PURCHASE">Purchase</option>
                                                        <option value="DEBIT NOTE">Debit Note</option>
                                                    </select>
                                                    <select onChange={this.changeTypePayStausFilter} className="form-control col-2" style={{display: 'inline-block',marginLeft: '4px'}}>
                                                        <option value="ALL">All Status</option>
                                                        <option value="Paid">Paid</option>
                                                        <option value="Partial">Partial</option>
                                                        <option value="Unpaid">Unpaid</option>
                                                    </select>
                                                    <select onChange={this.changePartyFilter} className="form-control col-3" style={{display: 'inline-block',marginLeft: '4px'}}>
                                                        <option value="ALL">All Party</option>
                                                        {this.state.partyData.map((item, index) => {
                                                            let _sel = "";
                                                            if (this.state.activePartyKey == item.party_id) {
                                                            _sel = "selected";
                                                            }
                                                            return (
                                                            <option
                                                                key={index}
                                                                value={item.party_id}
                                                                selected={_sel}
                                                            >
                                                                {item.party_name}
                                                            </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="col-lg-2">
                                                    
                                                <div className="row pb-20 pull-right">
                                                    <div className="text-right">
                                                        <div className="js-appear-enabled text-center">
                                                        <Link onClick={this.exportData} >
                                                            <div className="text-info">
                                                                <i className="fa fa-file-excel-o"></i>
                                                            </div>
                                                            <div className="font-size-sm text-muted">
                                                                    Excel Export
                                                            </div>
                                                        </Link>
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-6 text-right border-r">
                                                        <div className="js-appear-enabled text-center">
                                                            <div className="text-info"><i className="fa fa-file-excel-o"></i></div>
                                                            <div className="font-size-sm text-muted">Excel Export</div>
                                                        </div>
                                                    </div> */}
                                                    {/* <div className="col-6">
                                                        <div className="js-appear-enabled text-center">
                                                            <div className="text-success"><i className="fa fa-print"></i></div>
                                                            <div className="font-size-sm text-muted">Print</div>
                                                        </div>
                                                    </div> */}
                                                </div>
                                                </div>       
                                                <br />
                                            </div>
                                            <div className="col-lg-12">
                                                {/* <div className="blockAreaList">
                                                    <div className="py-10 text-left" id="paidArea">
                                                        <div className="text-muted">Paid</div>
                                                        <div className="font-size-h5 font-w600">{numberFormat(this.state.paidAmount)}</div>
                                                    </div>
                                                </div> */}
                                                {/* <div className="blockAreaListIcon"><i className="fa fa-plus"></i></div> */}
                                                
                                                <div className="blockAreaList">
                                                    {this.state.totalValueSign != '' &&
                                                    <div className="py-10 text-left" id="unpaidAreaGreen">
                                                        <div className="text-muted">Balance Due</div>
                                                        <div className="font-size-h5 font-w600">{numberFormat(this.state.unpaidAmount)}</div>
                                                    </div>
                                                    } 
                                                    {this.state.totalValueSign === '' &&
                                                    <div className="py-10 text-left" id="unpaidAreaRed">
                                                        <div className="text-muted">Balance Due</div>
                                                        <div className="font-size-h5 font-w600">{numberFormat(this.state.unpaidAmount)}</div>
                                                    </div>
                                                    }
                                                </div> 
                                                {/* <div className="blockAreaListIcon"><i className="fas fa-equals"></i></div> */}

                                                <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

                                                <div className="blockAreaList">
                                                    <div className="py-10 text-left" id="totalArea">
                                                        <div className="text-muted">Total</div>
                                                        <div className="font-size-h5 font-w600">
                                                            {this.state.totalValueSign} {numberFormat(this.state.total)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                </div>                               
                            </div>
                        </div>
                    </div>

                    <div className="block" style={{marginTop: '0px'}}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="block">
                                    <div className="block-content">
                                        <h2 className="block-title ml-10">Transactions</h2>
                                        <input type="text" className="form-control col-6" style={{display:'inline-block'}} placeholder='search bill number (type at least three characters)'onChange={this.getInvoiceSearch}/>
                                        
                                        <Link
                                            to={"/business/add-purchase/"}
                                            style={{}}
                                            className="pull-right btn btn-sm btn-primary"
                                        >
                                            <i className="fa fa-plus-circle"></i> Add Purchase bill
                                        </Link>
                                        {/* <Link to={"/business/add-purchase/"} style={{marginTop: '35px'}} className="pull-right pull-right btn btn-sm btn-primary mb-10">
                                            <i className="fa fa-plus-circle"></i> Add Purchase Bill
                                        </Link> */}
                                    </div>
                                    <div className="block-content" id="tableData">
                                        <MDBDataTableV5 
                                            hover
                                            span
                                            displayEntries={false}
                                            entries={100}
                                            pagingTop={false}
                                            searchTop={false}
                                            searchBottom={false}
                                            info={false}
                                            barReverse
                                            data={this.loadTranscListing()}
                                        />
                                    </div>
                                    <div style={{ float: "right", marginTop: "-15px" }}>
                                        <div className="d-flex align-items-center justify-content-end">
                                            <div className="d-flex align-items-center">
                                            <div role="status" aria-live="polite"> Rows per page:</div>
                                            </div>
                                            <div className="d-flex align-items-center" >
                                            <select className=" d-flex align-items-center custom-select custom-select-sm form-control form-control-sm"
                                                    onChange={(event) => {
                                                        event.preventDefault();
                                                        const { name, value } = event.target;
                                                        this.setState(prevState => ({
                                                                pageCount : value,
                                                                setPage : 1,
                                                            }),
                                                            () => {
                                                                this.getSaleListData(1,this.state.searchInvNo,
                                                                    value
                                                                );
                                                            });
                                                    }}>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                            </div>
                                            <div className="d-flex align-items-center">
                                            <div role="status" aria-live="polite"> Total: {this.state.totalCount}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="block-content">
                                        <div style={{ float: "left", marginTop: "-45px" }}>
                                        <PaginationControl
                                            between={this.state.pageCount}
                                            total={this.state.totalCount}
                                            limit={this.state.pageCount}
                                            changePage={(page) => {
                                            this.setState({ setPage: page });
                                            this.getSaleListData(this.state.activeTransactionKey,this.state.activeTransactionPaymentKey,page,this.state.activePartyKey,this.state.searchInvNo,this.state.pageCount
                                            );
                                            }}
                                            ellipsis={1}
                                            activeClass={this.state.setPage}
                                            page={this.state.setPage}
                                        />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Modal Payment History Data List*/}
                <Modal
                    isOpen={this.state.modalPaymentHistory}
                    ariaHideApp={false}
                    size="sm"
                    aria-labelledby="modal-popout"
                    onRequestClose={this.closeModalHandler}
                    id="modalPaymentHistory"
                >
                    <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="block block-themed block-transparent mb-0">
                        <div className="block-header bg-primary-dark">
                            <h3 className="block-title">Payment History</h3>
                            <div className="block-options">
                            <button
                                type="button"
                                className="btn-block-option"
                                onClick={this.closeModalHandler.bind(
                                    this,
                                    "modalPaymentHistory"
                                )}
                            >
                                <i className="si si-close"></i>
                            </button>
                            </div>
                        </div>
                        <div className="block-content">
                            <QuickPaymentHistory
                                historyData={this.state.activePaymentHistory}
                                transId={this.state.trasactionHisId}
                                receivedAmount={this.state.receivedAmount}
                                type={'Purchase return'}
                            />
                        </div>
                        <br />
                        </div>
                        <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-alt-secondary"
                            onClick={this.closeModalHandler.bind(
                                this,
                                "modalPaymentHistory"
                            )}
                        >
                            Close
                        </button>
                        </div>
                    </div>
                    </div>
                </Modal>
                {/* Modal Payment History Data List*/}
        
                {/* Modal Payment History Data List*/}
                <Modal
                    isOpen={this.state.modalPaymentHistoryPurchase}
                    ariaHideApp={false}
                    size="sm"
                    aria-labelledby="modal-popout"
                    onRequestClose={this.closeModalHandler}
                    id="modalPaymentPurchaseHistory"
                >
                    <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="block block-themed block-transparent mb-0">
                        <div className="block-header bg-primary-dark">
                            <h3 className="block-title">Payment History</h3>
                            <div className="block-options">
                            <button
                                type="button"
                                className="btn-block-option"
                                onClick={this.closeModalHandler.bind(
                                    this,
                                    "modalPaymentPurchaseHistory"
                                )}
                            >
                                <i className="si si-close"></i>
                            </button>
                            </div>
                        </div>
                        <div className="block-content">
                            <QuickPaymentPurchaseHistory
                                transactionType={this.state.transactionType}
                                historyData={this.state.activePaymentHistory}
                                transId={this.state.trasactionHisId}
                                paidAmount={this.state.paidAmount}
                            />
                        </div>
                        <br />
                        </div>
                        <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-alt-secondary"
                            onClick={this.closeModalHandler.bind(
                                this,
                                "modalPaymentPurchaseHistory"
                            )}
                        >
                            Close
                        </button>
                        </div>
                    </div>
                    </div>
                </Modal>
                {/* Modal Payment History Data List*/}
                <div id="global_loader" className={_loader}>
                    <div className="gl-ldr-cld">
                        <div className="gl-ldr-ctr">
                            <div className="gl-loader"></div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )    
    }
}